import { Button, Space, Switch, Table, Tag } from "antd";
import { useTranslation } from "react-i18next";

import type { ColumnsType } from "antd/es/table";
import { ICdicCoupon, ICoupon } from "@interfaces";
import { theme, useNotify } from "@utils";

import { memo } from "react";
import { Link } from "react-router-dom";
import { PATH_COUPON_FAMILY, dateFormat, enumStatus, formatDateTime } from "@configs";
import { useDispatch } from "react-redux";
import { setLoading } from "@redux";
import { couponApi } from "@api";
import dayjs from "dayjs";

interface IProps {
  data: ICdicCoupon[];
  callback: () => void;
}
export const CdicCouponTable = memo(({ data, callback }: IProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { success, error } = useNotify();

  const dataSource: ICdicCoupon[] = data;
  const color = (status: enumStatus) => {
    switch (status) {
      case enumStatus.ACTIVE:
        return theme.colors.active;
        break;
      case enumStatus.INACTIVE:
        return theme.colors.expired;
        break;
      case enumStatus.REDEEMED:
        return theme.colors.main;
        break;
      case enumStatus.REJECT:
        return theme.colors.reject;
        break;
      default:
        return theme.colors.expired;
        break;
    }
  };
  const getStatus = (status: enumStatus) => {
    switch (status) {
      case enumStatus.ACTIVE:
        return t("page.active");
        break;
      case enumStatus.INACTIVE:
        return t("page.inactive");
        break;
      case enumStatus.REJECT:
        return t("page.rejected");
        break;
      case enumStatus.REDEEMED:
        return t("page.redeemed");
        break;
      case enumStatus.EXPIRED:
        return t("page.expired");
        break;
      default:
        return status;
        break;
    }
  };
  const columns: ColumnsType<ICdicCoupon> = [
    // {
    //   title: t("page.program_name"),
    //   dataIndex: "programName",
    //   key: "1",
    //   render: (text, record) => (
    //     <Link to={`${PATH_COUPON_FAMILY}/${record.couponFamilyId}`}>
    //       {record?.program?.programName}
    //     </Link>
    //   ),
    //   sorter: (a, b) => {
    //     if (a?.program?.programName && b?.program?.programName) {
    //       return a?.program?.programName.localeCompare(b?.program?.programName);
    //     } else {
    //       return 1;
    //     }
    //   },
    // },
    {
      title: t("page.program_name"),
      dataIndex: "programName",
      key: "7",
      render: (text, record) => (
        <span>{record?.programName}</span>
      )
    },
    {
      title: t("page.coupon_code"),
      dataIndex: "couponCode",
      key: "1",
      render: (text, record) => <span>{record?.couponCode}</span>,
      sorter: (a, b) => {
        if (a?.couponCode && b?.couponCode) {
          return a?.couponCode.localeCompare(b?.couponCode);
        } else {
          return 1;
        }
      },
    },
    {
      title: t("page.service_category"),
      dataIndex: "category",
      key: "2",
      render: (text, record) => <span>{record?.category}</span>,
      sorter: (a, b) => {
        if (a?.category && b?.category) {
          return a?.category.localeCompare(b?.category);
        } else {
          return 1;
        }
      },
    },
    {
      title: t("page.created_date"),
      dataIndex: "createdAt",
      key: "3",
      render: (data) => <span>{dayjs(data).format(formatDateTime)}</span>,
    },
    {
      title: t("page.valid_from"),
      dataIndex: "validFrom",
      key: "3",
      render: (text, record) => <span>{dayjs(record?.validFrom).format(dateFormat)}</span>,
      sorter: (a, b) => {
        if (a?.validFrom && b?.validFrom) {
          return a?.validFrom.localeCompare(b?.validFrom);
        } else {
          return 1;
        }
      },
    },
    {
      title: t("page.valid_to"),
      dataIndex: "validTo",
      key: "4",
      render: (text, record) => <span>{dayjs(record?.validTo).format(dateFormat)}</span>,
      sorter: (a, b) => {
        if (a?.validTo && b?.validTo) {
          return a?.validTo.localeCompare(b?.validTo);
        } else {
          return 1;
        }
      },
    },
    {
      title: t("page.user_name"),
      key: "5",
      render: (text, record) => <span>{record?.client?.name ?? '-'}</span>,
    },
    {
      title: t("page.phone_number"),
      key: "6",
      render: (text, record) => <span>{record?.client?.phoneNumber ?? '-'}</span>,
    },
    {
      title: t("page.clinic_name"),
      key: "7",
      render: (text, record) => <span>{record?.clinic?.clinicName ?? '-'}</span>,
    },
    {
      title: t("page.doctor_name"),
      key: "8",
      render: (text, record) => <span>{record?.doctor?.name ?? '-'}</span>,
    },
    {
      title: t("page.status"),
      dataIndex: "status",
      key: "5",
      render: (status) => (
        <Tag color={color(status)} key={status}>
          {getStatus(status)}
        </Tag>
      ),
    },
    

    // {
    //   title: t("page.coupon_family"),
    //   dataIndex: "familyName",
    //   key: "2",
    //   render: (text, record) => <span>{record?.familyName}</span>,
    //   sorter: (a, b) => {
    //     if (a?.familyName && b?.familyName) {
    //       return a?.familyName.localeCompare(b?.familyName);
    //     } else {
    //       return 1;
    //     }
    //   },
    // },
    // {
    //   title: t("page.total_numbers_of_coupon"),
    //   dataIndex: "noOfCoupons",
    //   key: "3",
    //   render: (tag) => (
    //     <Tag color={"#00AA67"} key={tag}>
    //       {tag}
    //     </Tag>
    //   ),
    // },
    // {
    //   title: t("page.total_numbers_of_used_coupon"),
    //   dataIndex: "noOfUsedCoupons",
    //   key: "4",
    // },
    {
      title: t("page.actions"),
      key: "6",
      render: (_, record) => (
        <Space size="middle">
          <Button disabled={record?.status !== enumStatus.ACTIVE} type="primary" size={"small"} onClick={()=>handleSendSms(record)}>
            {t("page.resend_sms")}
          </Button>
          <Switch checked={record?.status === enumStatus.ACTIVE} onChange={(value: boolean) => onChange(value, record)} />
          {/* <Space>
            <Link to={PATH_COUPON_LIST + `/${record.couponFamilyId}`}>
              <Button type="ghost" icon={<EditOutlined />} size={"small"} />
              <span>{t("page.edit")}</span>
            </Link>
          </Space> */}
        </Space>
      ),
    },
  ];

   const handleSendSms = async (record: ICdicCoupon) => {    
      try {
        dispatch(setLoading(true));
        await couponApi.resendSmsCdic(
          {
            userId: record?.client?._id,
            couponCode: record?.couponCode          
          }
        );
        // await callback();
        success(t("message.send.resend_success"));
      } catch (err: any) {
        error(t("message.update.fail"));
        dispatch(setLoading(false));
      } finally {
        dispatch(setLoading(false));
      }
    };

  const onChange = async (value: boolean, record: ICdicCoupon) => {
    const updateStatus = value ? enumStatus.ACTIVE : enumStatus.INACTIVE;
    try {
      dispatch(setLoading(true));
      await couponApi.updateCdicCoupons(
        {
          ...record,
          status: updateStatus,
        },
        record._id || ""
      );
      callback();
      success(t("message.update.success"));
    } catch (err: any) {
      error(t("message.update.fail"));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <Table dataSource={dataSource} rowKey={"couponFamilyId"} columns={columns} pagination={false} />
  );
});
